import React, { Component } from 'react';
import styled from 'styled-components';
import { COLOR } from 'admin/constants/styles';
import PropTypes from 'prop-types';

const ProgressBarContainer = styled.div`
  margin: 20px 0;
  display: flex;
`;

const ProgressBarHolder = styled.div`
  position: relative;
  flex-grow: 1;
  height: 20px;
  border-radius: 15px;
  background: ${COLOR.success};
`;

const ProgressBarBar = styled.div`
  position: absolute;
  height: 100%;
  width: 0%;
  border-radius: 15px;
  background: ${COLOR.corporatePrimaryColor};
  transition: width 0.3s ease;
`;

const ProgressBarText = styled.div`
  padding-left: 10px;
  height: 20px;
  line-height: 20px;
`;

class ProgressBar extends Component {
  render() {
    const css = {
      width: `${Math.round((this.props.current / this.props.max) * 100)}%`,
    };
    const prefix = this.props.prefix ? `${this.props.prefix} ` : '';
    const count = this.props.showMax ? `${this.props.current}/${this.props.max}` : `${this.props.current}`;
    return (
      <ProgressBarContainer>
        <ProgressBarHolder>
          <ProgressBarBar style={css} />
        </ProgressBarHolder>
        <ProgressBarText>{prefix + count + this.props.unit}</ProgressBarText>
      </ProgressBarContainer>
    );
  }
}

ProgressBar.propTypes = {
  unit: PropTypes.string,
  prefix: PropTypes.string,
  max: PropTypes.number,
  showMax: PropTypes.bool,
  current: PropTypes.number,
};

ProgressBar.defaultProps = {
  unit: '%',
  prefix: '',
  max: 100,
  showMax: false,
  current: 0,
};

export default ProgressBar;
